var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5234 13.9692C15.4596 13.9717 16.374 13.6949 17.1511 13.1739C17.9282 12.6529 18.533 11.9111 18.889 11.0422C19.2451 10.1734 19.3364 9.21647 19.1514 8.29258C18.9664 7.36869 18.5134 6.51929 17.8498 5.85179C17.1861 5.18429 16.3415 4.72868 15.4229 4.54256C14.5042 4.35644 13.5528 4.44817 12.6888 4.80617C11.8248 5.16416 11.0871 5.77233 10.569 6.55377C10.0508 7.33521 9.77557 8.25482 9.77797 9.19632C9.78118 10.4588 10.2829 11.6709 11.1729 12.566C12.0628 13.4611 13.2681 13.9659 14.5234 13.9692Z",
    fill: "#051B66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6319 25.8635C21.9461 25.8643 22.2471 25.7395 22.4688 25.5165C22.6904 25.2936 22.8145 24.9907 22.8137 24.6745C22.8081 22.4614 21.9291 20.3366 20.3699 18.7676C18.8107 17.1987 16.6991 16.314 14.4996 16.3082C12.3 16.3024 10.1928 17.176 8.64145 18.7368C7.09007 20.2976 6.22162 22.4178 6.22716 24.6309C6.22795 24.9471 6.35353 25.2506 6.57627 25.4748C6.79901 25.6989 7.10067 25.8253 7.41489 25.8261L21.6319 25.8635Z",
    fill: "#051B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c886c4ac5c845ee0f7caee9de29601a2.svg";
export { ForwardRef as ReactComponent };